import { red, green } from '@material-ui/core/colors'

export const styles = theme => ({
  error: {
    backgroundColor: red[500],
    color: theme.palette.getContrastText(red[500])
  },
  success: {
    backgroundColor: green[500],
    color: theme.palette.common.white
  }
})



// WEBPACK FOOTER //
// ./src/components/EnhancedSnackbar/styles.js